module.exports = __webpack_public_path__ + "static/img/6.a487565.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/1/6.png
// module id = pFKc
// module chunks = 1